import { Col, Row } from "antd";
import "../dpo-my-checklist/dpoMyChecklist.css";
import {
  Button,
  Select,
  Checkbox,
  Modal,
  Input,
  DatePicker,
  Form,
  Divider,
  Space
} from "antd";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { isEmpty, set } from "lodash";
import AddObligations from "../dpo-my-checklist/AddObligations";
import TasksPerOwnerV2 from "../../components/tasksPerOwnerV2/TasksPerOwnerV2";
import CircleGauge from "../../components/circleGauge/CircleGauge";
import { PlusOutlined } from "@ant-design/icons";
import styles from "./dpoInternal.module.css";
import { updateOrganizationInternalCategories } from "../../store/organizations/actions";
import {
  massAssignInternalObligations,
  createInternalObligation
} from "../../store/internalObligations/actions";
// import { sendEmail } from "../../store/forms/actions"; //old email service
// import { sendEmail } from "../../store/email/actions";
import { renderOptions } from "../../util/basicRenders";
// import { assignToUserMessage } from "../../util/emailTemplates";
import FilterObligations from "../../components/filterObligations/FilterObligations";
import { filterObligations } from "../../util/filters";
import { sortObligationsBy } from "../../util/sorters";
import { ReactComponent as Triangle } from "../../assets/purple-triangle.svg";

const DpoInternal = () => {
  const dispatchito = useDispatch();
  dayjs.extend(customParseFormat);

  const sortingTypes = ["", "asc", "desc"];
  const [sortingOrder, setSortingOrder] = useState(sortingTypes[0]);
  const [orderBy, setOrderBy] = useState("");

  const [form] = Form.useForm();
  const mainOptions = useSelector(
    state => state.organizations.organizationIdCategories ?? []
  );
  const [options, setOptions] = useState(mainOptions);
  const [value, setValue] = useState("");
  useEffect(() => {
    setOptions(mainOptions);
  }, [mainOptions]);
  const [option, setOption] = useState("");
  const user = useSelector(state => state.user);
  const organizations = useSelector(state => state.organizations.organizations);
  const originalInternal = useSelector(
    state => state.internalObligations.internalObligations ?? []
  );
  const internalObligations = useSelector(
    state => state.internalObligations.forms
  );
  const usersData = useSelector(state => state.organizations.usersData);
  const organizationId = useSelector(
    state => state.organizations.organizationId
  );
  const activeCompany =
    organizations?.find(item => item._id === organizationId) ?? {};
  //create login link
  const loginLink = `http://${process.env.REACT_APP_FILE_HOST}/regcom/login`;

  //set local state
  //set local state for selected obligations
  const [selectedInternalObligations, setSelectedInternalObligations] =
    useState([]);
  const [massAssignSelectedPersonId, setMassAssignSelectedPersonId] =
    useState("");
  const [searchValue, setSearchValue] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [added, setAdded] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [scrolled , setScrolled] = useState(false);
  const [firstRender , setFirstRender] = useState(false);
  const targetId = useSelector(state => state.internalObligations.navigateId);

  const displayedObl = internalObligations;
  const startIndex = (currentPage - 1) * 5;
  const endIndex = startIndex + 5;

  const filteredUsers = useSelector(state => state.forms?.filteredUsers);
  const filterUsers = useSelector(state => state.forms?.filterUsersEnabled);

  const category = useSelector(state => state.forms?.selectedCategory);
  const searchFilter = useSelector(state => state.forms?.searchTerm);
  const dueDateFrom = useSelector(state => state.forms?.dueDateFrom);
  const dueDateTo = useSelector(state => state.forms?.dueDateTo);
  const selectedAction = useSelector(state => state.forms?.selectedAction);
  const selectedAssessment = useSelector(
    state => state.forms?.selectedAssessment
  );

  const filteredObligations =
    filterUsers ||
    category ||
    searchFilter ||
    dueDateFrom ||
    dueDateTo ||
    selectedAction ||
    selectedAssessment
      ? filterObligations({
          obligationList: originalInternal,
          flag: "internal",
          filters: {
            filterUsers,
            filteredUsers,
            category,
            searchTerm: searchFilter,
            action: selectedAction,
            assessment: selectedAssessment,
            dueDateFrom,
            dueDateTo
          }
        })
      : originalInternal;
  const filteredObligationsForm =
    sortingOrder || orderBy
      ? !isEmpty(internalObligations) && !isEmpty(filteredObligations)
        ? sortObligationsBy(
            filteredObligations,
            "internal",
            orderBy,
            sortingOrder
          )?.map(o => {
            const relevantObligation = internalObligations?.find(
              obl => o._id === obl._id
            );
            return relevantObligation;
          })
        : sortObligationsBy(
            filteredObligations,
            "internal",
            orderBy,
            sortingOrder
          )
      : filteredObligations?.map(o => {
          const relevantObligation = internalObligations?.find(
            obl => o._id === obl._id
          );
          return relevantObligation;
        });

  const displayedItems =
    filteredObligationsForm &&
    filteredObligationsForm.slice(startIndex, endIndex);

  const countCompliantTasks = itemList =>
    itemList && itemList.filter(item => item.assessment === "Compliant").length;

  const currentUsersData = usersData
    ? usersData?.filter(
        b =>
          b.role === "assignedUser" || b.role === "corporateComplianceAssessor"
      )
    : [];

  const panelStyle = {
    marginBottom: 24,
    borderRadius: 16,
    border: "none"
  };

  const toggleOrder = () => {
    const currentIndex = sortingTypes.indexOf(sortingOrder);
    const nextIndex = (currentIndex + 1) % sortingTypes.length;
    setSortingOrder(sortingTypes[nextIndex]);
    return sortingTypes[nextIndex];
  };

  const handleClearMessage = ({ event, id, key, type }) => {
    const index = internalObligations.findIndex(item => item._id === id);
    dispatchito({
      type: "UPDATE_INTERNAL_OBLIGATION_FORMS",
      payload: { index, event, key }
    });
  };

  const handleMassAssign = async (items, targetUserId) => {
    if (isEmpty(items)) return;
    const oblIds = items.map(i => {
      return i._id;
    });
    dispatchito(
      massAssignInternalObligations({
        targetUserId,
        oblIds,
        user,
        organizationId,
        callback: check => {
          setMassAssignSelectedPersonId("");
          setChecked(check);
          setSelectedInternalObligations([]);
          // const userAssigned = usersData?.find(
          //   item => item._id === targetUserId
          // );
          // if (targetUserId)
          //   items.forEach(item => {
          //     dispatchito(
          //       sendEmail({
          //         user,
          //         to: [userAssigned.email],
          //         cc: [],
          //         subject: "Assign Internal Obligations",
          //         message: assignToUserMessage(item, user),
          //         isHtmlMessage: true
          //         // message: 'HELLO text',
          //         // isHtmlMessage: false,
          //       })
          //     );
          //   });
        }
      })
    );
  };

  const [oblValue, setOblValue] = useState("");

  const handleChangeAddObl = ({ event, id, key, type }) => {
    const index = internalObligations.findIndex(item => item._id === id);
    const value =
      type === "select"
        ? event
        : type === "date"
        ? new Date(event).toISOString()
        : event.target.value;
    dispatchito({
      type: "UPDATE_INTERNAL_OBLIGATION_FORMS",
      payload: { index, value, key }
    });
  };

  const handleCancel = async () => {
    setIsOpen(false);
    form.resetFields();
    clearOption();
    setOblValue("");
    setMainCategory("");
    setSelectedDate(null);
  };

  const handleSortClick = by => {
    if (orderBy !== by) {
      setSortingOrder("asc");
    } else {
      toggleOrder();
    }
    setOrderBy(by);
  };

  const addMore = async () => {
    form.validateFields().then(values => {
      let formData = new FormData();
      formData.append(
        "description",
        values.description ? values.description : ""
      );
      formData.append("info", values.info ? values.info : "");
      formData.append("category", values.category ? values.category : "");
      formData.append("dueDate", values.dueDate ? values.dueDate : "");

      dispatchito(
        createInternalObligation({
          payload: formData,
          user,
          organizationId,
          callback: check => {
            setAdded(check);
          }
        })
      );
      form.resetFields();
      setIsOpen(false);
      setOblValue("");
      setMainCategory("");
      setSelectedDate(null);
    });
  };

  const onCheckboxAllChange = () => {
    if (checked) {
      setSelectedInternalObligations([]);
      setChecked(false);
    } else {
      const uniqueValuesSet = new Set([
        ...selectedInternalObligations,
        ...displayedItems
      ]);
      const uniqueValuesArray = Array.from(uniqueValuesSet);
      setSelectedInternalObligations(uniqueValuesArray);
      setChecked(true);
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [mainCategory, setMainCategory] = useState("");

  useEffect(() => {
    if (targetId === 0 && scrolled) {
      if(firstRender){
        setCurrentPage(1);
        // setSortingOrder(sortingTypes[0]);
        // setOrderBy("");
      }
      setFirstRender(true);
    }
  }, [filterUsers, organizationId, category, searchFilter, dueDateFrom, dueDateTo, selectedAction, selectedAssessment]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      const filtered = !isEmpty(mainOptions)
        ? mainOptions.filter(option =>
            option?.toLowerCase().includes(searchTerm.toLowerCase())
          )
        : [];

      setOptions(filtered);
    } else {
      setOptions(mainOptions);
    }
  }, [searchTerm]);

  const onOptionChange = event => {
    setSearchTerm(event.target.value);
    setOption(event.target.value);
  };

  const clearOption = () => {
    setOption("");
  };

  const addOption = () => {
    if (option.trim() && !mainOptions.includes(option.trim())) {
      dispatchito(
        updateOrganizationInternalCategories(
          user,
          activeCompany?._id,
          option.trim()
        )
      );
    }
    setOptions(mainOptions);
    form.validateFields().then(values => {
      values.category = option.trim();
      form.setFieldsValue(values);
    });
    setMainCategory(option.trim());
    clearOption();
  };

  const [okDisabled, setOkDisabled] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = date => {
    setSelectedDate(date);
    console.debug("Selected Date:", date);
  };

  useEffect(() => {
    if (oblValue !== "" && mainCategory !== "" && selectedDate !== null) {
      setOkDisabled(false);
    } else {
      setOkDisabled(true);
    }
  }, [oblValue, mainCategory, selectedDate]);

  console.debug("mainCategory:", mainCategory);

  return (
    <div className="ob" id="ob-page">
      <FilterObligations
        defaultCat={""}
        organizationId={organizationId}
        sortedUniqueMainCategories={
          options
            ? options?.map(option => {
                return { value: option, label: option };
              })
            : []
        }
        obligationType="internal"
      />
      <Row
        className="mb-3"
        id="ob-page-rows"
        gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
      >
        <Col span={6}></Col>
        <Col span={18}></Col>

        <Col span={17} style={{}}>
          <TasksPerOwnerV2
            users={usersData ?? []}
            obligations={internalObligations ?? []}
          />
        </Col>
        <Col span={1} flex="1.938rem"></Col>
        <Col span={6} style={{}}>
          <div
            className="compliance-score-content"
            id="ob-page-compliance-score-content"
          >
            <h4
              className="component-title"
              id="ob-page-component-title"
              style={{ marginBottom: "1.563rem" }}
            >
              Compliance Score
            </h4>
            <div
              className="compliance-score-gauge"
              id="ob-page-compliance-score-gauge"
            >
              <CircleGauge
                score={
                  internalObligations &&
                  Array.isArray(internalObligations) &&
                  !isEmpty(internalObligations)
                    ? Math.round(
                        (countCompliantTasks(internalObligations) /
                          internalObligations.length) *
                          100
                      )
                    : 0
                }
              />
            </div>
          </div>
        </Col>
      </Row>

      {/* --------------Internal Regulations & Frameworks -------------------------------*/}

      <div className="shaded-border" id="ob-page-shaded-border">
        <div className="obligation-table" id="ob-page-obligation-table">
          <div
            className={styles.largeTitlesBlack}
            id={`ob-page-${styles.largeTitlesBlack}`}
          >
            Internal Obligations{" "}
          </div>
          <div
            style={{
              width: "99.7%",
              height: "100%",
              border: "0.063rem #D5D0C9 solid"
            }}
          ></div>
          <div
            id="mass-assign-internals"
            style={{ display: "flex", gap: "0.25rem", marginTop: "0.813rem" }}
          >
            <Checkbox
              id="ob-page-checkbox"
              style={{
                marginTop: "5px",
                marginLeft: "-23px"
              }}
              checked={checked}
              onChange={e => onCheckboxAllChange()}
              disabled={
                user.role === "corporateComplianceObserver" ||
                user.role === "groupComplianceObserver"
              }
            />
            <Select
              // dropdownStyle={{ maxHeight: "17rem" }}
              virtual={false}
              id={user.email}
              style={{ width: "15rem", textAlign: "left" }}
              className="assign-select mb-2"
              showSearch
              onSearch={setSearchValue}
              filterOption={false}
              allowClear={!!massAssignSelectedPersonId}
              placeholder="Select..."
              disabled={
                user.role === "corporateComplianceObserver" ||
                user.role === "groupComplianceObserver"
              }
              onChange={value => setMassAssignSelectedPersonId(value)}
              value={
                !massAssignSelectedPersonId
                  ? massAssignSelectedPersonId
                  : currentUsersData &&
                    !isEmpty(currentUsersData) &&
                    Array.isArray(currentUsersData) &&
                    currentUsersData.length > 0 &&
                    currentUsersData
                      ?.filter(b => b._id === massAssignSelectedPersonId)
                      .map(b => `${b.firstName} ${b.lastName}`)
              }
            >
              {/* {console.debug("usersData value:", usersData)} */}
              {currentUsersData && renderOptions(searchValue, currentUsersData)}
            </Select>
            {user.role !== "corporateComplianceObserver" &&
              user.role !== "groupComplianceObserver" && (
                <div
                  id="mass-assign-internals-div"
                  onClick={() =>
                    handleMassAssign(
                      selectedInternalObligations,
                      massAssignSelectedPersonId
                    )
                  }
                >
                  <Button
                    className="assign-button-rc no-margin"
                    id="ob-page-assign-button-rc"
                    type="text"
                    size="medium"
                  >
                    Assign
                  </Button>
                </div>
              )}
          </div>
          <Row
            className="mb-2"
            id="ob-page-rows-mb-2"
            gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
            style={{ marginLeft: "1.6rem", marginRight: "2rem" }}
          >
            {/* <Col span={1}>
              <span className="title-style"></span>
            </Col> */}
            {/* <Col span={1}>
              <span className="title-style">ID</span>
            </Col> */}
            <Col></Col>
            
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-id-col"
            >
              <span
                className="title-style sortable"
                id="ob-page-title-style"
                style={{ paddingLeft: "0.438rem" }}
                onClick={() => handleSortClick("code")}
              >
                ID
                {orderBy === "code" && sortingOrder ? (
                  sortingOrder === "desc" ? (
                    <Triangle />
                  ) : (
                    <Triangle style={{ transform: "rotate(180deg)" }} />
                  )
                ) : (
                  <></>
                )}
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-category-col"
            >
              <span
                className="title-style sortable"
                id="ob-page-title-style-3"
                style={{ paddingLeft: "0.375rem" }}
                onClick={() => handleSortClick("mainCategory")}
              >
                Category{orderBy === "mainCategory" && sortingOrder ? sortingOrder === "desc" ? <Triangle/> : <Triangle style={{transform: "rotate(180deg)"}}/> : <></>}
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-obligation-col"
            >
              <span
                className="title-style"
                id="ob-page-title-style-6"
                style={{ paddingLeft: "0.438rem" }}
              >
                Obligation
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-action-col"
            >
              <span className="title-style" id="ob-page-title-style-7" style={{ marginLeft: "-0.438rem" }}>
                Action
              </span>
            </Col>
            <Col
              // span={3}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-assessment-col"
            >
              <span className="title-style" id="ob-page-title-style-8" style={{ marginLeft: "-0.375rem" }}>
                Assessment
              </span>
            </Col>
            <Col
              // span={3}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-due-col"
            >
              <span className="title-style" id="ob-page-title-style-9" style={{ marginLeft: "-0.125rem" }}>
                Due Date
              </span>
            </Col>
            {/* <Col span={2}>
              <span className="title-style">Comments</span>
            </Col> */}
            <Col
              // span={2}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-submit-col"
            >
              <span className="title-style" id="ob-page-title-style-10"></span>
            </Col>
          </Row>

          <AddObligations
            id="ob-page-add-obligations"
            handleChangeAddObl={handleChangeAddObl}
            handleClearMessage={handleClearMessage}
            usersData={currentUsersData || []}
            currentPage={currentPage}
            setChecked={setChecked}
            setCurrentPage={setCurrentPage}
            displayedItems={displayedItems ?? []}
            panelStyle={panelStyle}
            added={added}
            setAdded={setAdded}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            addObligations={filteredObligationsForm}
            organization={organizationId}
            myTask={false}
            selectedInternalObligations={selectedInternalObligations}
            setSelectedInternalObligations={setSelectedInternalObligations}
            scrolled={scrolled}
            setScrolled={setScrolled}
          />

          <Col span={24}>
            {user.role !== "corporateComplianceObserver" &&
              user.role !== "groupComplianceObserver" && (
                <Button
                  id="add-additional-obl"
                  className="mt-2 addMoreBtn"
                  // onClick={addMore}
                  onClick={() => setIsOpen(true)}
                >
                  Add New
                </Button>
              )}
          </Col>
          <div className="collapse-margin" id="ob-page-collapse-margin">
            {" "}
          </div>
        </div>
      </div>
      <Modal
        id="modal1"
        title="Add Internal Obligation"
        open={isOpen}
        centered
        width={580}
        onOk={addMore}
        onCancel={handleCancel}
        okButtonProps={{ disabled: okDisabled }}
        okText="Create"
        cancelButtonProps={{ id: "cancel-add-obligation" }}
        // okButtonProps={{ id: "ok-add-obligation" }}
      >
        <Form requiredMark={false} id="form1" form={form} layout="vertical">
          <Form.Item
            label={
              <span>
                Obligation<span className="color-asterisk">{" *"}</span>
              </span>
            }
            name="description"
            id="home-editor-page-form-2"
          >
            <Input.TextArea
              rows={4}
              value={oblValue}
              onChange={e => setOblValue(e.target.value)}
            />
          </Form.Item>
          <Form.Item label="Info" name="info" id="home-editor-page-form-2">
            <Input.TextArea rows={4} />
          </Form.Item>
          <Form.Item
            label={
              <span>
                Category<span className="color-asterisk">{" *"}</span>
              </span>
            }
            name="category"
          >
            <Select
              virtual={false}
              value={mainCategory}
              onChange={value => setMainCategory(value)}
              dropdownRender={menu => (
                <div>
                  <div>{menu}</div>
                  <div
                    style={{
                      position: "sticky",
                      bottom: "0",
                      backgroundColor: "#FAFAFA"
                    }}
                  >
                    <Divider style={{ margin: "8px 0" }} />
                    <Space style={{ backgroundColor: "#FAFAFA" }}>
                      <Input
                        placeholder="Please enter new item"
                        value={option}
                        onChange={onOptionChange}
                      />
                    </Space>
                    <Space
                      style={{
                        backgroundColor: "#FAFAFA",
                        marginTop: "8px"
                      }}
                    >
                      <Button
                        type="text"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          addOption();
                          clearOption();
                        }}
                      >
                        <b>&nbsp;Add item</b>
                      </Button>
                    </Space>
                  </div>
                </div>
              )}
              options={options.map(item => ({
                label: item,
                value: item
              }))}
            />
          </Form.Item>
          <Form.Item
            label={
              <span>
                Due Date<span className="color-asterisk">{" *"}</span>
              </span>
            }
            id="home-editor-page-form-3"
            name="dueDate"
            // rules={[
            //   // {
            //   //   required: true,
            //   //   message: "Please input the due date!"
            //   // },
            //   //make sure due date is not before (or same as) law in-force date
            //   () => ({
            //     validator(rule, value) {
            //       const inForce = selectedDocument.inForceDate.slice(
            //         0,
            //         10
            //       ); //is ISO string and keep only date part
            //       // console.debug(
            //       //   "Inside add obligation, inForceDate:",
            //       //   inForce
            //       // );
            //       const due = value
            //         ? value.toISOString().slice(0, 10)
            //         : "";
            //       // console.debug("testing field rules for date:", due);
            //       if (due && due < inForce) {
            //         //setInvalidDueDate(true)
            //         // console.debug(
            //         //   "due date prior to in force: ",
            //         //   due < inForce
            //         // );
            //         return Promise.reject([
            //           "Due Date cannot be prior to In Force Date."
            //         ]);
            //       }

            //       return Promise.resolve();
            //     }
            //   })
            // ]}
          >
            <DatePicker
              format="DD-MM-YYYY"
              value={selectedDate}
              onChange={handleDateChange}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default DpoInternal;
